import { render, staticRenderFns } from "./AppletSettings.vue?vue&type=template&id=1cffec10&scoped=true&"
import script from "./AppletSettings.vue?vue&type=script&lang=js&"
export * from "./AppletSettings.vue?vue&type=script&lang=js&"
import style0 from "./AppletSettings.vue?vue&type=style&index=0&id=1cffec10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cffec10",
  null
  
)

export default component.exports